import { signalStore, withState, withMethods, patchState, withComputed, withProps } from '@ngrx/signals';
import { computed, inject, resource } from '@angular/core';
import { PolicyGridService } from './policy-grid.service';

export const PolicyGridStore = signalStore(
  { providedIn: 'root' },
  withState<{filterValues: object}>({
    filterValues: <object>{},
  }),
  withComputed((state) => ({
    debug: computed(() => ({
      filterValues: state?.filterValues?.(),
    })),
  })),
  withMethods((store) => ({
    setFilterValues(value: object) {
      patchState(store, {
        filterValues: value,
      });
    },
  })),
  withProps((store, policyGridService = inject(PolicyGridService)) =>({
    resource: resource({
      request: store.filterValues,
      loader: async (request) => {
        const filter = request.request;
        const submissionGrid = await policyGridService.getPolicyGrid(filter);
        return submissionGrid;
      }
    })
  }))
);